 <div class="d-flex justify-content-between flex-wrap align-items-center">
   <h2 class="block-title">
     {{ 'Invoices' | translate }}
   </h2>
 </div>
 <div class="  table-responsive mb-5">
   <table class="table table-default ">
     <thead class="table-header text-center">
       <tr>
         <th scope="col">{{ 'Event' | translate }}</th>
         <th scope="col">{{ 'Amount' | translate }}</th>
         <th scope="col">{{ 'Payment status' | translate }}</th>
         <th scope="col">{{ 'Invoice date' | translate }}</th>
         <th scope="col">{{ 'Action' | translate }}</th>
       </tr>
     </thead>
     <tbody class="table-body">
       <tr class="  text-center" *ngFor="let item of [1,1,1,1,1,1]">
         <td scope="col">
           محمد ابو سليمان
         </td>
         <td scope="col">٢٣٠ ريال</td>
         <td class=" text-primary" scope="col">تم التحويل</td>
         <td scope="col">٢٢/٣/١٤٤٢</td>

         <td scope="col">
           <!-- ... -->
           <div ngbDropdown class="d-inline-block px-5">
             <button class="btn p-0 text-primary dropdown-noArrow" id="ticketActions" ngbDropdownToggle>
               <i class="fas fa-ellipsis-h"></i>
             </button>
             <div ngbDropdownMenu aria-labelledby="ticketActions">

               <a [routerLink]="['/dashboard/account/invoice-details']" ngbDropdownItem>
                 <i class="fas fa-pencil-alt  mr-2 text-primary"></i>
                 {{ 'Edit' | translate }}
               </a>
               <a [routerLink]="['/']" ngbDropdownItem>
                 <i class="far fa-trash-alt  mr-2 text-primary"></i>
                 {{ 'Delete' | translate }}
               </a>

             </div>

           </div>
         </td>
       </tr>
     </tbody>
   </table>
 </div>
